module.exports = __webpack_public_path__ + "img/4b746.14124a70.svg";